import axios from "axios";

// export const baseURL = "http://xh.ahksss.cn/";
export const baseURL = "http://www.axp.com.cn/";


export const http = axios.create({
  baseURL: baseURL, // 替换为你的API基地址
  timeout: 10000, // 请求超时时间
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    // 可以在这里添加例如token等请求头
    // if (store.getters.token) {
    //   config.headers['Authorization'] = `Bearer ${store.getters.token}`;
    // }
    return config;
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    // 对响应数据做处理，例如只返回data部分
    return response.data;
  },
  (error) => {
    // 响应错误处理
    return Promise.reject(error);
  }
);
